const CONFIG = {
    FOLDER_NAME: 'Medias',
};

export default CONFIG;